import Reflux from 'reflux';

const LdapGroupsActions = Reflux.createActions({
  'loadGroups': {asyncResult: true},
  'loadMapping': {asyncResult: true},
  'saveMapping': {asyncResult: true},
});

export default LdapGroupsActions;



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/graylog-project-cli-release/workspace/.repos/graylog2-server/graylog2-web-interface/src/actions/ldap/LdapGroupsActions.js